import { render, staticRenderFns } from "./StandardCompliance.vue?vue&type=template&id=07807196&scoped=true&"
import script from "./StandardCompliance.vue?vue&type=script&lang=js&"
export * from "./StandardCompliance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07807196",
  null
  
)

export default component.exports